import React from 'react';
import PropTypes from 'prop-types';

/**
 * 파트너 쿠폰 할인가
 */
function PartnerBurdenDiscount({
  couponType,
  discountAmount,
  discountPercent,
  maxAmount,
}) {
  return (
    <>
      {couponType === 'AMOUNT' || couponType === 'CARTM' ? (
        <span className="partner_burden_discount">
          ({TMON.util.numberFormat(discountAmount)}원 할인)
        </span>
      ) : (
        <span className="partner_burden_discount">
          ({TMON.util.numberFormat(discountPercent)}% 할인, 최대{' '}
          {TMON.util.numberWithString(maxAmount)}원)
        </span>
      )}
    </>
  );
}

PartnerBurdenDiscount.propTypes = {
  couponType: PropTypes.string,
  discountAmount: PropTypes.number,
  discountPercent: PropTypes.number,
  maxAmount: PropTypes.number,
};

export default PartnerBurdenDiscount;
